import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCalendarRoute: InvariantJiraRoute = {
	name: 'software-calendar',
	path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/:itemId?',
	query: ['date?'],
};
